import { bem } from '../../core/design/bem';
import '../SocialWall.scss';
import ImageTile from '../components/ImageTile';
import { SocialWallVariant } from '../types/SocialWallTypes';
import './Grid.scss';

const css = bem('Grid');

const Grid = ({ items, openLightbox }: SocialWallVariant): JSX.Element | null => {
  const photos = items.filter((i) => !!i.image);

  return (
    <div className={css()}>
      {photos.map((item) => (
        <ImageTile key={item.id} item={item} openLightbox={openLightbox} />
      ))}
    </div>
  );
};

export default Grid;
